import { render } from "./Example10.vue?vue&type=template&id=a39be93a"
import script from "./Example10.vue?vue&type=script&lang=ts"
export * from "./Example10.vue?vue&type=script&lang=ts"
script.render = render

export default script